module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="card-mobile flex-column">\n\n    <div>\n        ' +
((__t = (data.id_stock || '&nbsp;')) == null ? '' : __t) +
'\n    </div>\n\n    <div>\n        ' +
((__t = (data.stockLocation || '&nbsp;')) == null ? '' : __t) +
'\n    </div>\n\n</div>';

}
return __p
}